<template>
  <div>
    <div class="locales-layout">
      <HeaderMenuLocaleSection
        :locales="systemLocales"
        locale-type="system"
        @stageLocaleChanges="stageLocaleChanges"
      />
      <HeaderMenuLocaleSection
        :locales="contentLocales"
        :content-locale="contentLocale"
        locale-type="content"
        @stageLocaleChanges="stageLocaleChanges"
      />
    </div>
    <BaseModal
      :is-open="isChangeLocaleModalDisplayed"
      border-radius-size="small"
      @close="closeModalConfirmLocaleChanges"
    >
      <div class="modal-change-language">
        <h2 class="modal-change-language__title">{{ $t('WARNING') }}</h2>
        <p>
          {{ $t('mainMenu.language.LOCALE_CHANGE_WARNING') }}
        </p>
        <div class="modal-action-buttons">
          <BaseButton
            outline
            size="large"
            @click="closeModalConfirmLocaleChanges()"
          >
            {{ $t('buttons.CANCEL') }}
          </BaseButton>
          <BaseButton
            v-if="stagedLocale.type === 'system'"
            theme="blue"
            :disabled="isSubmittingLocale"
            :loading="isSubmittingLocale"
            size="large"
            @click="setSystemLocale(stagedLocale.code)"
          >
            {{ $t('mainMenu.language.CHANGE_LANGUAGE') }}
          </BaseButton>
          <BaseButton
            v-else
            theme="blue"
            :disabled="isSubmittingLocale"
            :loading="isSubmittingLocale"
            size="large"
            @click="setContentLocale(stagedLocale.code)"
          >
            {{ $t('mainMenu.language.CHANGE_LANGUAGE') }}
          </BaseButton>
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import BaseButton from '@/components/generics/base/BaseButton.vue'
import BaseModal from '@/components/generics/base/BaseModal.vue'
import HeaderMenuLocaleSection from '@/components/layout/header/HeaderMenuLocaleSection.vue'
import {
  setLocaleStorageContentLocale,
  systemLocales,
} from '@/helpers/localeHelper'
import { useCurrentCompany } from '@/hooks/swr/useCurrentCompany'
import { useCompanyLocale } from '@/hooks/useCompanyLocale'
import { useContentLocale } from '@/hooks/useContentLocale'
import { loadLocales } from '@/i18n/lib/i18n'
import ApiService from '@/service/api.service.js'
import { TRIGGER_CONTENT_LOCALE_UPDATE } from '@/store/modules/common/mutation-types'

export default {
  components: {
    BaseButton,
    BaseModal,
    HeaderMenuLocaleSection,
  },
  setup() {
    const { contentLocaleOptions: contentLocales } = useCompanyLocale()
    const { contentLocale } = useContentLocale()
    const { data: currentCompany } = useCurrentCompany()
    return { contentLocales, contentLocale, currentCompany }
  },
  data() {
    return {
      stagedLocale: {
        code: undefined,
        type: undefined,
      },
      isSubmittingLocale: false,
      isChangeLocaleModalDisplayed: false,
      systemLocales,
    }
  },
  methods: {
    stageLocaleChanges(payload) {
      this.stagedLocale.type = payload.localeType
      this.stagedLocale.code = payload.localeCode
      this.isChangeLocaleModalDisplayed = true
    },
    closeModalConfirmLocaleChanges() {
      this.isChangeLocaleModalDisplayed = false
    },
    async submitLocaleWrapper(localeCode, callback) {
      this.isSubmittingLocale = true
      await callback(localeCode)
      this.isSubmittingLocale = false
      this.closeModalConfirmLocaleChanges()
    },
    async setSystemLocale(localeCode) {
      this.submitLocaleWrapper(localeCode, async () => {
        await ApiService.updateUsersMe({
          locale: localeCode,
        })
        loadLocales({ locale: localeCode })
      })
    },
    setContentLocale(localeCode) {
      this.submitLocaleWrapper(localeCode, async () => {
        setLocaleStorageContentLocale(this.currentCompany.name_key, localeCode)
        this.$store.commit(TRIGGER_CONTENT_LOCALE_UPDATE)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.locales-layout {
  border-top: 1px solid $color-border;
  display: flex;
  flex-direction: column;
  gap: $spacing-xs;
  padding: $spacing-3xs $spacing-4xs 0;
}

.modal-change-language {
  padding: $spacing-m;
  min-width: 500px;
  max-width: 500px;

  &__title {
    @include subtitle;
    margin-bottom: $spacing-5xs;
  }

  .modal-action-buttons {
    margin-top: $spacing-l;
    @include form-action-buttons-layout;
  }
}
</style>
